export var InputType;
(function (InputType) {
    InputType["text"] = "text";
    InputType["number"] = "number";
    InputType["email"] = "email";
    InputType["tel"] = "tel";
    InputType["password"] = "password";
    InputType["date"] = "date";
})(InputType || (InputType = {}));
export var FormError;
(function (FormError) {
    FormError["Required"] = "required";
    FormError["MinLength"] = "minLength";
    FormError["MaxLength"] = "maxLength";
    FormError["Minimum"] = "minimum";
    FormError["Maximum"] = "maximum";
})(FormError || (FormError = {}));
//# sourceMappingURL=FormTypes.js.map